exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cookies[data-v-b1fe1108]{position:fixed;bottom:0;left:0;right:0;height:auto;background:#3c434c;color:#fff;padding:10px;border-top:1px solid #666}.left[data-v-b1fe1108]{width:30px;display:inline-block;float:left;font-size:32px}a[data-v-b1fe1108]{cursor:pointer}.right[data-v-b1fe1108]{width:calc(100% - 140px);display:inline-block;float:left;font-size:14px}@media (max-width:520px){.cookies[data-v-b1fe1108]{padding:10px}.right[data-v-b1fe1108]{width:calc(100% - 90px);display:inline-block;float:left;font-size:12px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-b1fe1108","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Cookies.vue
// module id = 37
// module chunks = 24